var cssInstalledChunks = {"main": 0,};
var cssLoadingUniqueName = "fluxer_app";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = function(chunkId, url, done, hmr, fetchPriority) {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;


	}
	var onLinkComplete = function(prev, event) {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = function(chunkId, promises, fetchPriority) {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (!/^(mobx(|\-async)|src_(app_(Route(r_ts\-packages_constants_src_ExternalUrls_ts\-packages_constants_src_PolicyConstan\-8f27af|s_ts\-src_features_app_state_ActiveInstanceProductName_ts\-src_features_i18n_utils\-3d7d0b)|SetupHttp_ts\-src_features_app_config_I18nDisplayConstants_ts\-src_features_platform_st\-d3470c)|features_(messaging_(utils_markdown_(EmojiProviderSetup|parser_MarkdownParserWasm)_ts|state_AttachmentUrlRefresher_ts)|p(re(mium_state_DismissedUpsell_ts\-src_features_premium_utils_PremiumCheckoutRetur\-1f309c|sence_events_PresenceUpdate_ts\-src_features_presence_events_PresenceUpdateBul\-955b1d)|latform_(s(tate_(ResetClientState_ts(|\-src_features_updater_commands_UpdaterModalCom\-9e39c0)|LegacySharedContentReview_ts)|ervice_worker_Register_ts)|push_PushSubscriptionService_ts)|ermissions_system_components_MacPermissionPrompt_tsx)|i(18n_(locales_(zh\-(CN|TW)_messages_mjs|h[eiru]_messages_mjs|e(s\-(419|ES)_messages_mjs|(l|n\-GB)_messages_mjs)|([knr]o|[aft]r|bg|cs|da|de|fi|id|it|ja|lt|nl|pl|pt\-BR|ru|sv\-SE|th|uk|vi)_messages_mjs)|utils_CommonMessageDescriptors_ts)|nput_state_InputKeybind_ts|nvite_components_pages_InviteAuthPageState_tsx)|a(pp_(state_(GeoIP|Updater)_ts|co(mponents_(dialogs_(shared_(DesktopEntitySettingsView_tsx\-src_features_app_com\-643fbd|SettingsSection_tsx)|ModalStack_tsx\-src_features_app_hooks_usePlatformClasses_\-957860)|floating_ColorPickerPopover_tsx|layout_DropIndicator_tsx\-src_features_ui_components_form_ColorPic\-f6518d|shared_ImagePreviewField_tsx\-src_features_expressions_utils_Anima\-620a65)|nfig_I18nDisplayConstants_ts\-src_features_(platform_(state_ResetClientState_\-b2e924[01]|types_Versioning_ts\-pac\-2fdba0)|input_components_modals_Keyboard\-646902))|domain_migration_DomainMigrationAppStorage_ts)|uth_(state_((AuthFlow|ResetPasswordTokenCheck)_ts|NewDeviceMonitoring_tsx)|flow_(A(uth(FirstScreen_ts|RouterLink_tsx\-src_features_auth_flow_auth_login_core_AuthLoginIns\-acabcc|RuntimeTargetGate_tsx\-src_features_auth_flow_AuthRuntimeTargetRese\-a4031e)|ccountRestrictionScreen_tsx)|(ForgotPasswordForm|MfaScreen|ResourceAuthPages)_tsx|client_intro_AuthClientPermissionStep_tsx\-src_features_auth_flow_clien\-f110c4)|components_(pages_(OAuthAuthorize|RecoverAccount)Page_tsx|ContentBlockedHandler_tsx)|altcha_CaptchaInterceptor_ts|passkey_migration_PasskeyBridgePage_tsx))|notification_utils_(BackgroundAccountNotifications|CustomSoundDB)_ts|search_(components_bottomsheets_QuickSwitcherBottomSheet_tsx|utils_UnicodeConfusables_ts)|u(ser_(components_modals_tabs_LanguageTab_tsx\-src_features_user_components_modals_\-dfffa3|state_StatusPage_ts)|i_(com(mands_NotificationCommands|ponents_form_DateTimePickerField)_tsx|button_Button_tsx\-src_features_ui_components_icons_FluxerIcon_tsx))|voice_(utils_(EspeakTtsFallback|MediaDeviceStartupPreload|noise_suppression_NoiseSuppressionWorkletAssets)_ts|components_(alerts_TtsUnsupportedModal|popout_VoiceTilePopoutContent)_tsx|(VoiceAccountLifecycle|diagnostics_VoiceSubscriptionDebugReport)_ts|state_CallAvailability_ts\-src_features_voice_state_CallMediaPrefs_ts\-src_f\-7b55c3)|theme_(studio_(commands_ThemeStudioCommands_ts|sections_QuickCssEditor_tsx)|components_pages_ThemeAuthPageConfig_tsx|utils_ThemeLibraryDb_ts)|expressions_components_pages_GiftAuthPageConfig_tsx|lexical_LexicalUndoRedoRegistry_ts\-src_features_lexical_composer_ComposerAutocom\-a5b5a9|webhook_state_Webhooks_ts\-src_features_window_state_LiveResize_ts)|media_images_avatars_0_png\-src_media_images_avatars_1_png\-src_media_images_avatars_2_png\-\-9b39e6)|v(endor(\-async\-[0123]|)|alidation|irtualizer\-async)|d(at(a_image_svg_xml_3Csvg_xmlns_http_www_w3_org_2000_svg_width_40_height_40_3E_3Crect_width_40\-52362b|etime\-async)|nd\-async)|tts\-(1|node_modules_pnpm_mespeak_2_0_2_node_modules_mespeak_src_ESpeak_js\-44fd8fd6)|r(eact(\-a(sync\-[0123]|ria\-async)|)|adix\-async)|i(18n(|\-async)|cons(|\-async))|u(tils(|\-async)|(i|nicode)\-async)|(animation|calendar|lexical|livekit|observable|qrcode|webrtc)\-async|editor|katex\-async\-node_modules_pnpm_katex_0_18_7_node_modules_katex_dist_katex_mjs\-193504e1|node_modules_pnpm_arborium_arborium_2_18_2_node_modules_arborium_arborium_dist_lazy_recursive\-38c42f|packages_instance_bootstrap_src_OfficialWebAppHosts_ts|platform)$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
